import * as _ from 'lodash';
import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { _tk, _ti } from '@wephone-translation';
import {
  DialogService,
  DynamicFilterSource,
  FlexTableComponent,
  IFlexDialogConfig
} from '@wephone-utils';
import { DialogComponentBase } from '@wephone-core-ui';
import { BehaviorSubject, Observable } from 'rxjs';
import { CallDirection, ICallDial } from '@wephone-app-phone/pages/history/calllog.i';
import { CallQueueEntity } from '@wephone-core/model/entity/callqueue';
import { EntityManager } from '@wephone-core/wephone-core.module';
import { CallQueueRepository } from '@wephone-core/model/repository/callqueue';
import { MatDialogRef } from '@angular/material/dialog';
import { CallLogService } from '@wephone-core/service/call_log_service';


@Component({
  selector: 'app-quick-dialer',
  templateUrl: './quick-dialer.component.html',
  styleUrls: ['./quick-dialer.component.scss']
})
export class QuickDialerComponent extends DialogComponentBase implements OnInit {
  static modalConfig: IFlexDialogConfig = {
    size: 'l',
    width: '100%',
    minHeight: '90%'
  };

  dialogTitle = _tk('call_active.last_dials');
  highlightIdx: number = 0;
  countTotal: number = 100;

  tableConfig: any;
  dataSource: DynamicFilterSource;
  private _dataSource: BehaviorSubject<ICallDial[]>;
  private queues: { [key: string]: CallQueueEntity } = {};


  @ViewChild('flexTable') flexTable: FlexTableComponent;
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    // this.loggerService.log('keycode', event.keyCode);
    switch (event.keyCode) {
      case 38:
      case 40:
        if (event.keyCode === 38) { // Up key
          // this.loggerService.log('Press updown key up');
          this.highlightIdx --;
          if (this.highlightIdx < 0) {
            this.highlightIdx = 0;
          }
        }

        if (event.keyCode === 40) { // Down key
          // this.loggerService.log('Press updown key down');
          this.highlightIdx ++;
          if (this.highlightIdx > this.countTotal) {
            this.highlightIdx = this.countTotal;
          }
        }

        if (this.flexTable) {
          this.flexTable.highlightRow(this.highlightIdx);
          this.updateDialogLayout();
        }
        break;
      case 13: // Enter
        const row = this.dataSource.data && this.dataSource.data[this.highlightIdx];
        if (row) {
          this.selectItem(null, row);
        }
        break;
      default:
        break;
    }
  }

  constructor(
    dialogRef: MatDialogRef<QuickDialerComponent>,
    public dialogService: DialogService,
    private callLogService: CallLogService
  ) {
    super(dialogRef);
    this._dataSource = new BehaviorSubject<ICallDial[]>([]);
  }

  getDataSource<T extends ICallDial = any>(): Observable<T[]> {
    return this._dataSource.asObservable() as Observable<T[]>;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const ds = this.getDataSource<ICallDial>();
    this.dataSource = new DynamicFilterSource(ds, null);

    this.tableConfig = {
      rowHeight: 50,
      multiSelect: false,
      enableFilter: false,
      enableExportCsv: false,
      columns: [
        {
          name: 'content'
        }
      ]
    };

    const queues: CallQueueEntity[] = EntityManager.getRepository<CallQueueRepository>('CallQueueRepository').getObjectList();
    for (const q of queues) {
      this.queues[q.id] = q;
    }

    await this.reloadData();
    this.flexTable.highlightRow(this.highlightIdx);
    this.updateDialogLayout();
  }

  getPhoneNumber(item: ICallDial): string {
    return item.user_direction == 2 ? item.called_number : item.calling_number;
  }

  selectItem($event, item: ICallDial): void {
    if ($event) {
      $event.stopPropagation();
    }

    const phoneNumber: string = this.getPhoneNumber(item).replace(/\D/g, '');
    if (phoneNumber) {
      this.dismiss({
        phone_number: phoneNumber
      });
    }
  }

  async reloadData(): Promise<any> {
    try {
      const resp: ICallDial[] = await this.callLogService.getLastDialedCalls();
      const historyList: ICallDial[] = [];
      this.countTotal = 0;

      for (const item of resp) {
        const historyItem: ICallDial = _.extend(item, {
          user_direction: CallDirection.OUTBOUND
        });

        historyList.push(historyItem);
        this.countTotal ++;
      }

      this._dataSource.next(historyList);
    } catch (error) {
      this.loggerService.error('Reload data error', error);
    }
  }

  getQueueName(call: ICallDial): string {
    if ((call.queue_ids || []).length === 0) {
      return;
    }
    const queueId = call.queue_ids[0];
    return this.queues && this.queues[queueId] && this.queues[queueId].queue_name;
  }

}
